import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nombre", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_ingreso", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (moment(item.fecha_ingreso,'DD/MM/YYYY').format('YYYY-MM-DD') + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("fecha_pasivo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (moment(item.fecha_pasivo,'DD/MM/YYYY').format('YYYY-MM-DD') + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("item", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.item + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("activo_pasivo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.activo_pasivo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },
        filternombre(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre: val
            });
        },
        filterFechaIngreso(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_ingreso: val
            });
        },
        filterFechaPasivo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_pasivo: val
            });
        },
        filterItem(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                item: val
            });
        },
        filterActivoPasivo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                activo_pasivo: val
            });
        },
        //-------------------------------------
        recargar() {
            this.form = {}
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_ingreso: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_pasivo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                item: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                activo_pasivo: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/permiso/mixins/Filtros.js